var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-list"},_vm._l((_vm.users),function(user){return _c('div',{key:("user-" + (user.name)),staticStyle:{"width":"35px","height":"35px","position":"relative"}},[_c('img',{staticClass:"img-circle m-right-5",attrs:{"src":user.avatar,"data-toggle":"tooltip","data-placement":"top","alt":user.name,"title":user.name}}),_vm._v(" "),_c('span',{staticClass:"label",class:{
        'label-success': user.online,
        'label-warning': !user.online,
      },staticStyle:{"display":"block","width":"10px","height":"13px","border-radius":"100px","position":"absolute","top":"0","right":"0"}})])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6edb80d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AppAvatarList.vue
// module id = L7aR
// module chunks = 0